import PhoenixOffcanvas from 'components/base/PhoenixOffcanvas';
import Section from 'components/base/Section';
import { useState, useEffect } from 'react';
import { Alert, Button, Col, Pagination, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Scrollbar from 'components/base/Scrollbar';
import ProductFilterItems from 'components/modules/e-commerce/products-filter/ProductFilterItems';
import ProductCard from 'components/common/ProductCard';
import ProductSpecialCard from 'components/common/ProductSpecialCard';
import {
  faChevronLeft,
  faChevronRight,
  faFilter
} from '@fortawesome/free-solid-svg-icons';
import { productService, Product } from 'services/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CACHE_KEY = 'cachedProducts';
const CACHE_DURATION = 60 * 60 * 1000; // 1 hora em milissegundos

const ProductsFilter = () => {
  const [specialProducts, setSpecialProducts] = useState<Product[]>([]);
  const [Products, setProducts] = useState<Product[]>([]);

  const copyEmailToClipboard = async () => {
    const email = 'alexandrebfaust@gmail.com';
    try {
      await navigator.clipboard.writeText(email);
      toast.success('Email copiado para a área de transferência!');
    } catch (error) {
      // Fallback para browsers mais antigos
      try {
        const textArea = document.createElement('textarea');
        textArea.value = email;
        document.body.appendChild(textArea);
        textArea.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        
        if (successful) {
          toast.success('Email copiado para a área de transferência!');
        } else {
          toast.error('Erro ao copiar email. Tente copiar manualmente.');
        }
      } catch (fallbackError) {
        toast.error('Erro ao copiar email. Tente copiar manualmente.');
      }
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      const debug = localStorage.getItem('debug') === 'true';
      const cachedData = localStorage.getItem(CACHE_KEY);

      if (cachedData && !debug) {
        const { products, timestamp } = JSON.parse(cachedData);
        const isCacheValid = (Date.now() - timestamp) < CACHE_DURATION;

        if (isCacheValid) {
          setSpecialProducts(products.filter((product: Product) => product.special));
          setProducts(products.filter((product: Product) => !product.special));
          return;
        }
      }

      try {
        const products: Product[] = await productService.listProducts();
        localStorage.setItem(CACHE_KEY, JSON.stringify({ products, timestamp: Date.now() }));
        setSpecialProducts(products.filter((product: Product) => product.special));
        setProducts(products.filter((product: Product) => !product.special));
      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div>
      <Section className="pt-5 pb-9">
        <Row>
          <Col lg={12} xxl={12} className="mb-4">
            <Alert key="info" variant="subtle-info">
              <p className='justify-content-center'>Aos que desejarem enviar o presente via Pix, pedimos a gentileza de utilizar a seguinte chave:</p>
              <span className='justify-content-center'>
                <strong>Chave PIX:</strong> <a 
                  rel="noopener noreferrer" 
                  onClick={copyEmailToClipboard}
                  style={{ cursor: 'pointer', textDecoration: 'underline' }}
                >
                  alexandrebfaust@gmail.com
                </a>
              </span>
            </Alert>
          </Col>
          <Col lg={12} xxl={12}>
            {specialProducts.length > 0 && (
              <Row className="gx-3 gy-6 mb-8 justify-content-center">
                {specialProducts.map(product => (
                  <Col xs={6} sm={6} md={4} xxl={4} key={product.productId}>
                    <div className="product-card-container h-100 d-flex justify-content-center align-items-center">
                      <ProductSpecialCard product={product} />
                    </div>
                  </Col>
                ))}
              </Row>
            )}
            {Products.length > 0 ? (
              <Row className="gx-3 gy-6 mb-8">
                {Products.map(product => (
                  <Col xs={6} sm={6} md={4} xxl={2} key={product.productId}>
                    <div className="product-card-container h-100">
                      <ProductCard product={product} />
                    </div>
                  </Col>
                ))}
              </Row>
            ) : (
              <div className="text-center">
                <p>Sem produtos disponíveis no momento.</p>
              </div>
            )}
          </Col>
        </Row>
      </Section>
      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default ProductsFilter;
